
















































































































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api'
import { StatLocation } from '~/models/statistics/types'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    CLink,
    CIcon
  },
  props: {
    statLocation: {
      type: Object as PropType<StatLocation>,
      required: true
    }
  },
  setup() {
    const isOpen = ref<Boolean>(true)

    const toggleOpen = () => {
      isOpen.value = !isOpen.value
    }

    const percentageVariation = (percentage: number | null): string => {
      if (percentage === null) return '-'
      return percentage > 0 ? `+${percentage}%` : `${percentage}%`
    }

    const isPositive = (percentage: number | null): boolean => {
      if (percentage === null) return false
      return percentage > 0
    }
    const isNegative = (percentage: number | null): boolean => {
      if (percentage === null) return false
      return percentage < 0
    }

    return {
      isOpen,
      ciAngleDownLight,
      toggleOpen,
      percentageVariation,
      isPositive,
      isNegative
    }
  },
  i18n: defineComponentTranslations({
    change: {
      en: 'Change %',
      el: 'Μεταβολή %'
    },
    change_description: {
      en: 'comparison with previous year',
      el: 'σύγκριση με προηγούμενο έτος'
    },
    average_price_per_sqm: {
      en: 'Average price per sq.m.',
      el: 'Μέση τιμή ανά τ.μ.'
    }
  })
})
